<div class="dialog-header">
  <mat-legacy-card-title
    mat-legacy-dialog-title
    class="d-flex align-items-center mb-1"
    style="gap: 0.5rem"
  >
    <mat-icon>{{ icon }}</mat-icon>
    {{ title }}
  </mat-legacy-card-title>

  <mat-card-subtitle>
    {{ subTitle }}
  </mat-card-subtitle>

  <mat-divider class="dialog-divider"></mat-divider>
</div>
